import React from 'react';
import Image from 'next/image';

import { Video } from '@edx/graphql/generated';
import { translateVideoLevel } from '@edx/helpers/video-levels';
import { IconAngleRight, IconPlaySolid } from '@edx/components/icons';
import { Link } from '@edx/components/link';
import { Badge } from '@edx/components/badge';
import { Slider } from '@edx/components/slider';

type Props = {
  items: Video[];
};

export const VideoSlider: React.FC<Props> = ({ items }) => (
  <>
    <Slider>
      {items.map(({ name, course, level, isPublic, resourcePath, imageUrl, description }) => (
        <div
          key={resourcePath}
          className="relative overflow-hidden min-w-3/4 sm:min-w-1/2 lg:min-w-1/3 pr-2 md:pr-4"
          data-testid="videoSlide"
        >
          <Link href={resourcePath} className="group flex flex-col overflow-hidden h-full min-w-48">
            <div className="relative">
              <Image
                className="object-cover"
                src={imageUrl as string}
                alt={name}
                layout="responsive"
                width={528}
                height={297}
              />

              <div className="absolute flex-col justify-between p-4 inset-0 flex bg-gray-800 bg-opacity-50 group-hover:bg-opacity-0 transition duration-150">
                <div className="flex">
                  <div className="p-2 bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 ease transform translate-y-3 group-hover:translate-y-0">
                    <IconPlaySolid className="text-primary-500 w-6" />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-grow group group-hover:bg-gray-600 group-hover:bg-opacity-40 transition duration-150">
              <div className="relative flex flex-col font-body text-gray-500 p-2 space-y-2">
                <header className="text-gray-100 leading-6">
                  <h2 className="inline text-lg">{name}</h2>
                  {isPublic && <Badge className="ml-2 flex-shrink text-10px font-medium align-top">Gratis</Badge>}
                </header>

                <div className="flex space-x-2">
                  <span className="text-xs text-gray-300 uppercase tracking-widest font-medium leading-relaxed">
                    {course.name}
                  </span>

                  <span className="text-xs uppercase tracking-widest font-medium leading-relaxed">
                    {translateVideoLevel(level)}
                  </span>
                </div>

                {description && <p>{description}</p>}

                <footer className="block md:hidden text-sm text-gray-300 font-medium flex">
                  Acceder <IconAngleRight className="w-3" />
                </footer>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </Slider>
  </>
);
